import type { ReactNode } from 'react'
import { Info, type LucideIcon } from 'lucide-react'
import { IconButton, Popover } from '@/components/play'

/**
 * A supporting explanation behind an info button. Keyboard focus, hover or a tap reveals it; focus stays on the
 * button and Tab moves on. Enter or Space opens it and moves focus in. It stays until Escape, a press outside or the
 * button closes it, and Escape returns focus to the button.
 */
export function WorkspaceInfo({
  label,
  children,
  icon: Icon = Info,
  className,
}: {
  label: string
  children: ReactNode
  icon?: LucideIcon
  className?: string
}) {
  return (
    <Popover
      openOnHover
      openOnFocus
      label={label}
      align="end"
      trigger={
        <IconButton label={label} variant="ghost" tooltip={false} className={className}>
          <Icon aria-hidden />
        </IconButton>
      }
    >
      {children}
    </Popover>
  )
}
